import { enumToEnumNames } from '@commonClient2/services/enums';

const LESS = 'less';
const EQUAL_OR_LESS = 'equalOrLess';
const EQUAL = 'equal';
const EQUAL_OR_MORE = 'equalOrMore';
const MORE = 'more';

export const BreakRuleTriggerType = Object.freeze({
    [LESS]: 0,
    [EQUAL_OR_LESS]: 1,
    [EQUAL]: 2,
    [EQUAL_OR_MORE]: 3,
    [MORE]: 4,
});

export const BreakRuleTriggerTypeNames = enumToEnumNames(BreakRuleTriggerType);

export default BreakRuleTriggerType;
